import botConfig from './.bot-config.json';

function constructBotConfig() {
  let missingFields = [];
  let requiredFields = ["name", "alias", "region"];

  requiredFields.forEach((field) => {
    if (!botConfig[field]) {
      missingFields.push(field);
    }
  });

  if (missingFields.length > 0) {
    throw new Error(
      `Missing fields from bot config: ${missingFields.join(", ")}`
    );
  }

  // Amplify v6 Lex V2 configuration format
  // The config is an object with bot names as keys
  let bots = {
    aliasId: botConfig.alias,
    botId: botConfig.botId || botConfig.name, // Use botId if provided, fallback to name
    localeId: botConfig.localeId || 'en_US',
    region: botConfig.region
  };

  return bots;
}

export { constructBotConfig }